// extracted by mini-css-extract-plugin
export default {"subTitle":"subTitle-gYoQA","caption":"caption-h64fM","value":"value-USIej"};